import {Component, OnInit, Input, ViewContainerRef, SimpleChanges, Inject} from '@angular/core';
import {FormGroup, FormBuilder, Validators} from "@angular/forms";
import {Modal} from "angular2-modal/plugins/bootstrap";
import {Overlay} from "angular2-modal";
import {ActivatedRoute, Router} from "@angular/router";
import {DOCUMENT} from "@angular/platform-browser";
import {RestaurantService} from "../../shared/services/restaurant/restaurant.service";
import {User} from "../../shared/model/user";
import {validateEmail} from "../../shared/validators/validate-email";
import {AuthService} from "../../shared/security/auth.service";
import {UserService} from "../../shared/services/user/user.service";
import {Code} from "../../shared/model/code";


@Component({
  selector: 'user-form',
  templateUrl: './user-form.component.html',
  styleUrls: ['./user-form.component.css'],
  providers:[Modal],
})
export class UserFormComponent implements OnInit {
  roles: string[] = ['Admin - Bill Pay','Admin','Monitor'];

  user:User;
  codeRecord:Code;

  form:FormGroup;


  @Input()
  initialValues:any;
   selectedRole:string;
  private selectorIsClicked:boolean;
  private restaurantId:string;
  private myPath:string;
   currentRestaurantName: string;
  private userId: any;
  private sub: any;
  private logedInSysID:string;
  private logedUserId:string;
  private logedRole:string;
  private adminDbAdmin:boolean;
   currentEmail:string;
  private isCreating:boolean;
  private isEditing:boolean;

  constructor(
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private restaurantservice:RestaurantService,
    private authService: AuthService,
    private userService:UserService,
    public modal: Modal,
    private router:Router,
    overlay: Overlay,
    vcRef: ViewContainerRef,
    @Inject(DOCUMENT) private document,
  ) {
    this.form = this.formBuilder.group({
      first: ['', [Validators.required, Validators.minLength(1)]],
      last: ['', [Validators.required, Validators.minLength(2)]],
      nickName: ['', [Validators.minLength(3)]],
      email:['',[Validators.required, validateEmail]],
      // password:['',[Validators.required,Validators.minLength(8)]],
      // confirm:['',Validators.required],
      isActive:[''],
      role:['',Validators.required]
    });

    this.selectorIsClicked = false;

    overlay.defaultViewContainer = vcRef;

  }

  ngOnInit() {


        let myRoute = this.route.snapshot;

        this.myPath = myRoute.url[0].path;


        this.isCreating = false;
        this.isEditing = false;

        switch(this.myPath) {
          case "create": {
            this.isCreating = true;
            break;
          }
          case "edit": {
            this.isEditing = true;
            break;
          }
          default: {
            this.messageIt("Error on registration", "Please contact your system adminstrator ");
            break;
          }
        }



     this.select("Monitor");


        if (this.isCreating){




        } else {


          this.userId = myRoute.params['id'];
          this.restaurantId = myRoute.params['XR'];


          const user$ = this.userService.getUserByKey(this.userId);
          user$
            .subscribe((theUser)=>{
            this.user = theUser;
            this.currentEmail = this.user.email;
          });



        }



        const relation = this.userService.getUserRole(this.restaurantId,this.userId);
        relation
          .subscribe((thisRelations) => {
          this.selectedRole =  this.userService.roleDisplay(thisRelations[0].$value);
          this.select(this.selectedRole);


            this.logedInSysID = this.authService.getUid();

            const logedUser$ = this.userService.getUser(this.logedInSysID);
            logedUser$
              .subscribe((user)=>{
                this.logedUserId = user.$key;
                const logRelation = this.userService.getUserRole(this.restaurantId,this.logedUserId);
                logRelation
                  .subscribe((logedRelation)=>{
                    this.logedRole = thisRelations[0].$value;
                    this.adminDbAdmin = this.selectedRole == 'admin-db';
                  });
              })
        });


        const rRestaurant$ = this.restaurantservice.getRestaurantByKey(this.restaurantId);
        rRestaurant$
          .subscribe((restaurant)=>{this.currentRestaurantName = restaurant.restaurant});


  }



  ngOnChanges(changes:SimpleChanges){

    if (this.form && changes['initialValues']){
      this.form.patchValue(changes['initialValues'].currentValue);

    }

  }

  showErrors(){

    for (let element in this.form.controls){
      for(let element1 in  this.form.controls[element].errors){
        this.form.controls[element].markAsDirty();
      }
    }
    if (this.selectedRole === "Select a role"){
      this.selectorIsClicked = true;
      this.form.controls['role'].markAsDirty();
    }

  }

  printOpening() {

    this.selectorIsClicked = true;
  }

  printClosing() {


    this.selectorIsClicked = true;
  }

  clicked(){

  }


  select(selectedRole:string) {

    this.selectedRole = selectedRole;
    this.form.controls['role'].setValue(selectedRole);

  }

  itHaveErrors(){

    const isValid = this.form.valid;

    return isValid;

  }


  showSelectorError(){
    const showError = this.selectedRole == "Select a role" && this.selectorIsClicked;

    return showError;
  }

  isErrorVisible(field:string,error:string){

    return this.form.controls[field].dirty && this.form.controls[field].errors && this.form.controls[field].errors[error];

  }

  reset() {
    this.form.reset();
  }

  get valid(){
    return this.form.valid;
  }

  get value(){
    return this.form.value;
  }


  setBlank(){

    this.form.reset();
    this.selectedRole = this.initialValues.role;
    this.selectorIsClicked = false;
  }

  itMatch(){
    const val = this.form.value;
    const itMatch = val.password == val.confirm;
    return itMatch;
  }


  messageIt(titleP: string, messageP: string) {

    this.modal.alert()
      .size('lg')
      .showClose(true)
      .title(titleP)
      .body(messageP)
      .open();
  }



}



// WEBPACK FOOTER //
// ./src/app/user/user-form/user-form.component.ts